export default __webpack_public_path__ + "static/media/Banner6.e13cc061.png";